import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';


// @mui
import {
  Card,
  Table,
  Stack,

  Button,

  TableRow,
  MenuItem,
  TableBody,
  TableCell,

  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  CircularProgress,
  Chip,
} from '@mui/material';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import CustomSnackBar from '../components/snackbar';
import MenuPopover from '../components/popover/menuPopover'
// sections
import { UserListHead } from '../sections/@dashboard/user';


// api
import { getUserList, deleteUserList, } from '../api/admin';

import { getAccountSummary } from '../api/account';
import UserListDialog from '../sections/dialogs/userListDialog';



// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
  { id: 'adminStatus', label: 'Status', alignRight: false },
  { id: '' },
];
// ----------------------------------------------------------------------



export default function UserList() {

  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)

  const [restaurantUsers, setRestaurantUsers] = useState([]);
  const [restaurantList, setRestaurantList] = useState([]);

  const [isLoading, setIsLoading] = useState(false)

  const [selectedItem, setSelectedItem] = useState(false)

  const [dialogOpen, setDialogOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [action, setAction] = useState('');

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [selectedRestaurant, setSelectedRestaurant] = useState('');

  const handleSelect = async (event) => {
    console.log(event.target.value);
    setSelectedRestaurant(event.target.value);
    try {
      const { data } = await getUserList(event.target.value);
      console.log({data});
      
      if (data.success) {
        setRestaurantUsers(data.data.users)
      }
    }
    catch (e) {
      console.log({ e });
    }
  };


  const fetchData = async () => {
    setIsLoading(true)
    try {

      const { data } = await getAccountSummary();
      if (data.success ) {

        setRestaurantList(data.data)
      }
      setIsLoading(false)
    }
    catch (e) {
      setIsLoading(false)
      // console.log({ e });
    }
  }

  // get admins list
  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    // console.log(id);
    // setIsButtonLoading(true)
    try {
      const { data } = await deleteUserList(id);
      setMenuOpen(null)
      // setIsButtonLoading(false)
      setSnackbarMessage({ msg: data.message, success: true });
      setSnackbarOpen(true);
    }
    catch (e) {
      // setIsButtonLoading(false)
      setSnackbarMessage({ msg: e.message, success: false });
      setSnackbarOpen(true);
    }
  }


  const handleOpenMenu = (event, item) => {
    // console.log(item);
    setSelectedItem(item)
    setMenuOpen(event.currentTarget);
  };

  // Dialog
  const handleDialogOpen = (item, str) => {
    if (item) {
      // console.log(item);
      setSelectedItem(item)
    }
    setAction(str)
    setDialogOpen(true);
  };



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };





  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };





  return (
    <>
      <Helmet>
        <title> Resaurant Users | RMS </title>
      </Helmet>

      <Box sx={{ height: '100%' }}>
        {!isLoading ? (
          <Box >

            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
              <Typography variant="h4" gutterBottom>
                Restaurant Users
              </Typography>

              <Button variant="contained" sx={{ borderRadius: 2 }} startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => handleDialogOpen(null, 'CREATE')}>
                Create User
              </Button>
            </Stack>

            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Choose a restaurant</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedRestaurant}
                label="Choose a restaurant"
                onChange={handleSelect}
              >
                {restaurantList.map(item => <MenuItem value={item._id}>{item.restaurantName}</MenuItem>)}
              </Select>
            </FormControl>
            {selectedRestaurant &&
            <Card>
              {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}

                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                    />
                    <TableBody>
                      {restaurantUsers && restaurantUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        const { _id, firstName, lastName, email, restaurantName, city, status, roleName } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1} role="checkbox" >
                            {/* <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell> */}

                            <TableCell component="th" >
                              <Stack direction="row" alignItems="center" spacing={2}>
                                {/* <Avatar alt={name} src={avatarUrl} /> */}
                                <Typography variant="subtitle2" noWrap>
                                  {firstName} {lastName}
                                </Typography>
                              </Stack>
                            </TableCell>


                            <TableCell align="left">{email}</TableCell>
                            <TableCell align="left">{roleName}</TableCell>
                            <TableCell align="left">
                             {status}
                            </TableCell>
                            
                            <TableCell align="right">
                              <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell>
                            {/* <TableCell align="right">

                              <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>


                            </TableCell> */}
                          </TableRow>
                        );
                      })}

                    </TableBody>


                  </Table>
                </TableContainer>

              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={restaurantUsers?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}> <CircularProgress /> </Box>
        )}
      </Box>
      {dialogOpen && <UserListDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} setRestaurantAdmin={setRestaurantUsers} setSnackbarMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen} selectedItem={selectedItem} action={action} restaurantList={restaurantList}/>}
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />
      <MenuPopover menuOpen={menuOpen} setMenuOpen={setMenuOpen} handleDialogOpen={handleDialogOpen} handleDelete={handleDelete} selectedItem={selectedItem} />
    </>
  );
}
